import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ExtraBalanceService from '../../../services/ExtraBalance';
import { Strings } from '../../../helpers';
import ExtraBalanceCompletedWrapperStyled from './styles/ExtraBalanceCompletedStyled';
import Loading from '../../General/Loading';
import ExtraBalanceError from '../ExtraBalanceError/ExtraBalanceError';
import ExtraBalanceMessageSuccess from './ExtraBalanceMessageSuccess';

const categoryNames = {
  balance: 'Saldo',
  data: 'Datos',
  minutes: 'Minutos',
};
const ExtraBalanceCompleted = ({ offer, closePanel }) => {
  const [loading, setLoading] = useState(false);
  const [purchaseData, setPurchaseData] = useState(null);
  const [serviceError, setServiceError] = useState(false);

  const purchase = () => {
    setLoading(true);
    ExtraBalanceService.purchase(offer.code)
      .then(([{ transaction }]) => {
        setPurchaseData(transaction);
      })
      .catch(() => {
        setServiceError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    purchase();
  }, []);

  const actualCategory = categoryNames[offer.category];

  return (
    <ExtraBalanceCompletedWrapperStyled>
      {loading && <Loading />}
      {!loading && serviceError && (
        <ExtraBalanceError
          serviceError
          retry={purchase}
          closePanel={closePanel}
          markOptions={{
            event: 'pagina-virtual',
            page: `/tienda/extra-saldo/${Strings.strToUrl(
              actualCategory
            )}/error`,
            pagename: 'Extrasaldo - Error deuda extrasaldo',
          }}
        />
      )}
      {!loading && !serviceError && purchaseData === 'ok' && (
        <ExtraBalanceMessageSuccess
          closePanel={closePanel}
          category={actualCategory}
        />
      )}
    </ExtraBalanceCompletedWrapperStyled>
  );
};

ExtraBalanceCompleted.propTypes = {
  offer: PropTypes.objectOf(PropTypes.shape).isRequired,
  closePanel: PropTypes.func.isRequired,
};
export default ExtraBalanceCompleted;
